import React, { Fragment } from 'react';
import ContentPanel from './ContentPanel';
import HeaderPanel from './HeaderPanel';

const AIRoadmap = (props) => (
  <>
    <HeaderPanel {...props} />
    <ContentPanel />
  </>
);

export default AIRoadmap;
